import guide						from './modules/guides/guide';
import messagesEditGlobalMessage	from './modules/messages/messages-edit-global-message';
// import messagesOverdueInoviceMessage	from './modules/messages/messages-overdue-invoice-message';
import questions					from './modules/questions/questions';
import slider						from './modules/slider/slider';
import tags							from './modules/tags/tags';
import app           				from '../shared/shared';

app.registerModules([
	guide,
	messagesEditGlobalMessage,
	// messagesOverdueInoviceMessage,
	questions,
	slider,
	tags
]);
